import React from 'react';
import { Switch } from 'antd';
import { observer } from 'mobx-react';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { ReactComponent as SetAsDefaultEntitySvg } from './svgs/set-as-default-entity-icon.svg';
import { ReactComponent as SetAsDefaultEntityTooltipSvg } from './svgs/set-as-default-entity-tooltip-icon.svg';
import {
  ActionRow,
  DefaultEntityActionWrapper,
  ActionLabel
} from '../../../../modules/entities/EditHoldingEntity/EditHoldingEntity.styles';

export const DefaultEntityAction = observer(({
  holdingEntityData,
  onDefaultEntityChange
}) => {
  return (
    <ActionRow>
      <DefaultEntityActionWrapper>
        <SetAsDefaultEntitySvg />
        <ActionLabel>
          Set as default entity
          <ModifiedTooltip
            title={'This is the default holding entity when an item is created'}
            placement="top"
          >
            <SetAsDefaultEntityTooltipSvg />
          </ModifiedTooltip>
        </ActionLabel>
      </DefaultEntityActionWrapper>
      <Switch
        checked={holdingEntityData.isDefault}
        onChange={(checked) => onDefaultEntityChange(checked)}
        className='holdingEntityDefaultSwitch'
      />
    </ActionRow>
  );
}); 